<dashboard-dialog-frame icon='fa-regular fa-graduation-cap' header='Mark All Graduated' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="graduation-mark-all-graduated-dialog p-2 d-flex flex-row align-items-baseline flex-wrap flex-sm-nowrap gap-2">
		@for(array of entrepreneurs(); track $index){
		<table class='pro-table pro-table-no-header m-0 w-100'>
			<tr>
				<th>Name</th>
				<th>Venture Name</th>
			</tr>
			@for(e of array; track $index){
			<tr>
				<td>{{ e.name }}</td>
				<td>{{ e.ventureName }}</td>
			</tr>
			}
		</table>
		}

	</div>

</dashboard-dialog-frame>